import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from "./landing"
import Detail from "./detail"
import LoginPage from './login';
import { AuthProvider } from './contexts/authContext';
import ProtectedRoute from './protectedRoute';

const App = () => {

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  return(
    
    <Router>
      <AuthProvider>
      <Routes>
          <Route path="/login" element={<LoginPage/>} />
          <Route path="/" element={
            <ProtectedRoute>
              <Home/>
            </ProtectedRoute>
          }/>
          <Route path="/clip/:id" element={<ProtectedRoute><Detail /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to={isAuthenticated ? "/home" : "/login"} />} />
        </Routes>
        </AuthProvider>
    </Router>

  )
}

export default App